import { BadgeCheck, Eye, Heart, MessageCircleQuestionMark, PencilSparkles, TextAlignStart } from "lucide-react";
import { t } from "../../global-components/src/i18nTranslate";
import "./style.css";

export function RequestCompanySealStep1(){
    return (
       
        <div className="content-benefits">
            <div className="benefits">
                <div>
                    <BadgeCheck name="edit_square" className="icon-benefits"/> 
                </div>
                <div>
                    {t("company.requestSeal.benefits.one")}
                </div>
            </div>
            <div className="benefits">
                <div>
                    <PencilSparkles name="edit_square" className="icon-benefits"/>
                </div>
                <div>
                    {t("company.requestSeal.benefits.two")}
                </div>
            </div>
            <div className="benefits">
                <div>
                    <Eye name="notifications" className="icon-benefits"/>
                </div>
                <div>
                    {t("company.requestSeal.benefits.four")}
                </div>
            </div>
            <div className="benefits">
                <div>
                    <TextAlignStart name="search" className="icon-benefits"/>
                </div>
                <div>
                    {t("company.requestSeal.benefits.three")}
                </div>
            </div>
            <div className="benefits">
                <div>
                    <Heart name="notifications" className="icon-benefits"/>
                </div>
                <div>
                    {t("company.requestSeal.benefits.six")}
                </div>
            </div>
            <div className="benefits">
                <div>
                    <MessageCircleQuestionMark name="headphones" className="icon-benefits"/>
                </div>
                <div>
                    {t("company.requestSeal.benefits.five")}
                </div>
            </div>
        </div>
    )
}